import React from 'react';

export default class ExistingUserSuccess extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
        }
    }

    componentDidMount() {
    }

    render() {
        return (
            <div className="homeContainer">
                <div className="homeWelcomeContent reset-password">
                    <div className="container-fluid">
                        <h1>
                            Thank you for taking the time to link your account. Please call TSCRA at <a href="tel:8002427820">1-800-242-7820</a> to finish the process.
                        </h1>                        
                    </div>
                </div>
            </div>
        )
    }
}